import { useEffect, useState } from 'react';
export const useSidebarLinkData = () => {
    const [sideNavData, setSideNavData] = useState([]);
    const [serverError, setServerError] = useState(null);
    useEffect(() => {
        setSideNavData([]);
        setServerError('');
    }, []);
    return {
        sideNavData,
        serverError,
    };
};
//# sourceMappingURL=useSidebarLinkData.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
